'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var components_Body2_index = require('../Body2/index.js');
var MuiCheckbox = require('@mui/material/Checkbox');
var FormControlLabel = require('@mui/material/FormControlLabel');
var checkboxChecked = require('../../checkbox-checked-01411b46.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var MuiCheckbox__default = /*#__PURE__*/_interopDefaultLegacy(MuiCheckbox);
var FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormControlLabel);

var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckboxIndeterminate = function SvgCheckboxIndeterminate(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    filter: "url(#checkbox-indeterminate_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    x: 2,
    y: 1,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#E83938"
  }))), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M6 9h10v2H6z"
  })), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("filter", {
    id: "checkbox-indeterminate_svg__a",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__namespace.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React__namespace.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React__namespace.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React__namespace.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React__namespace.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React__namespace.createElement("feOffset", null), /*#__PURE__*/React__namespace.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React__namespace.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React__namespace.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};

var StyledFormControlLabel = styled__default["default"](FormControlLabel__default["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var ICON_VIEWBOX = "0 0 18 18";
var iconStyles = styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  height: 18px;\n  width: 18px;\n"], ["\n  height: 18px;\n  width: 18px;\n"])));
var CheckboxEmptyIcon = styled__default["default"](checkboxChecked.SvgCheckboxEmpty).attrs({
    viewBox: ICON_VIEWBOX,
    title: 'an empty checkbox',
})(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconStyles);
var CheckboxCheckedIcon = styled__default["default"](checkboxChecked.SvgCheckboxChecked).attrs({
    viewBox: ICON_VIEWBOX,
    title: 'a checked checkbox',
})(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconStyles);
var CheckboxIndeterminateIcon = styled__default["default"](SvgCheckboxIndeterminate).attrs({
    viewBox: ICON_VIEWBOX,
    title: 'an indeterminate checkbox',
})(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconStyles);
var StyledCheckbox = styled__default["default"](MuiCheckbox__default["default"]).attrs({
    icon: React__default["default"].createElement(CheckboxEmptyIcon, null),
    checkedIcon: React__default["default"].createElement(CheckboxCheckedIcon, null),
    indeterminateIcon: React__default["default"].createElement(CheckboxIndeterminateIcon, null),
})(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n"], ["\n  :hover,\n  &.Mui-checked:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var primary = _a.theme.colors.background.primary;
    return primary;
});
var LabelText = styled__default["default"](components_Body2_index["default"])(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  margin-left: 5px;\n"], ["\n  display: inline-block;\n  margin-left: 5px;\n"])));
var Checkbox = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, disabled = _a.disabled, indeterminate = _a.indeterminate, name = _a.name, children = _a.children, onChange = _a.onChange, className = _a.className, _c = _a.label_placement, label_placement = _c === void 0 ? constants_properties.CHECKBOX_LABEL_PLACEMENT.END : _c;
    return (React__default["default"].createElement(StyledFormControlLabel, { className: className, ref: ref, labelPlacement: label_placement, control: React__default["default"].createElement(StyledCheckbox, { checked: checked, indeterminate: indeterminate, name: name, onChange: function (_event, checked) { return onChange && onChange(checked); } }), disabled: disabled, label: React__default["default"].isValidElement(children) ? (children) : (React__default["default"].createElement(LabelText, null, children)) }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports["default"] = Checkbox;
